import { Injectable, OnDestroy } from '@angular/core'
import { ExternalFileViewerKey } from '@helios/panels/external-file-viewer'
import {
  ExternalFileFilter,
  focusPanelAction,
  RootState,
  setFocusedExternalFileFilter,
  showRawDataAction,
} from '@helios/state-management'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

/**
 * Listen to redux for focused files and trigger the External File panel Redux action to focus the appropriate panel on the appropriate item.
 * Depending on the details of the particular break, this determines what item needs to be focused on and sets that item as focused in Redux.
 */
@Injectable()
export class ExternalFileEffects implements OnDestroy {
  private readonly _destroyed$ = new Subject<void>()

  constructor(
    private readonly store: Store<RootState>,
    private readonly actions$: Actions,
  ) {
    this.actions$
      .pipe(takeUntil(this._destroyed$), ofType(showRawDataAction))
      .subscribe(action => this.onExternalFileFocused(action['payload']))
  }

  ngOnDestroy(): void {
    this._destroyed$.next()
    this._destroyed$.complete()
  }

  private onExternalFileFocused(rawData: ExternalFileFilter | undefined) {
    if (!rawData) return
    this.store.dispatch(setFocusedExternalFileFilter(rawData))
    setTimeout(() => this.focusPanel(ExternalFileViewerKey))
  }

  private focusPanel(panelKey: string) {
    this.store.dispatch(focusPanelAction(panelKey))
  }
}
